import React, {useContext, useEffect, useState} from 'react';
import {WMSContext} from "../context/WMSContext";
import {
    getShipmentByExternalDeliveryNumber,
    getShipmentInCCTransit,
    getShipmentInReturn,
    setShipmentsInInventory
} from "../../../api/wms/shipment/shipment";
import WmsMobileLayout from "../wmsMobileLayout";
import {Card, CardContent, Grid, TableBody, TableCell, TableHead} from "@mui/material";
import PageTitle from "../../../components/WMS/Mobile/PageTitle";
import {FormattedDate, FormattedMessage} from "react-intl";
import SearchBar from "../../../components/List/components/SearchBar";
import Table from "../../../components/WMS/List/Table";
import TableRowHead from "../../../components/WMS/List/TableRowHead";
import TableCellHead from "../../../components/WMS/List/TableCellHead";
import TableRow from "../../../components/WMS/List/TableRow";
import {blueColor} from "../../../assets/jss/main";
import ActionLink from "../clickAndCollect/components/ActionLink";
import Pagination from "../../../components/WMS/List/Pagination";
import {BarCodeScannerContext} from "../../../contexts/barCodeScannerContext";
import CCShipmentModal from "./component/CCShipmentModal";
import CCErrorModal from "./component/CCErrorModal";
import TrolleyOrZoneDrawer from "./component/TrolleyOrZoneDrawer";
import {getWMSContainerWithCodeBar} from "../../../api/wms/wmsContainers/wmsContainers";
import {assignShipmentToContainer} from "../../../api/wms/shipment/shipment"
import {WmsContainerType} from "../../../utils/WMSContainerType";
import Toast from "../../../components/WMS/Toast";
import {ShipmentStatus} from "../../../utils/ShipmentStatus";
import {LineItemStatus} from "../../../utils/LineItemStatus";
import ReturnShipmentModal from "./component/ReturnShipmentModal";
import ValidProductDrawer from "./component/ValidProductDrawer";
import BeatLoaderRegular from "../../../components/loaders/BeatLoaderRegular";
import {ReactComponent as ValidIcon} from "assets/img/validated.svg";
import abort from "../../../utils/abort";

function CcReceptionList() {
    const {currentInventory, isMobile, currentOrganization} = useContext(WMSContext)
    const {scannedString, resetScannedString} = useContext(BarCodeScannerContext)

    const [apiTotalItemsCount, setApiTotalItemsCount] = useState(0)
    const [apiCurrentPage, setApiCurrentPage] = useState(1)

    const [shipments, setShipments] = useState([])
    const [selectedShipment, setSelectedShipment] = useState()
    const [isCC, setIsCC] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [currentPageShipments, setCurrentPageShipments] = useState([])
    const [pageCount, setPageCount] = useState()
    const [searchString, setSearchString] = useState()
    const [displayedShipments, setDisplayedShipments] = useState([])
    const [isRunner, setIsRunner] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const [openShipmentModal, setOpenShipmentModal] = useState(false)
    const [openReturnShipmentModal, setOpenReturnShipmentModal] = useState(false)
    const [openZoneDrawer, setOpenZoneDrawer] = useState(false)
    const [openValidProductDrawer, setOpenValidProductDrawer] = useState(false)
    const [openErrorModal, setOpenErrorModal] = useState(false)
    const [openToast, setOpenToast] = useState(false)
    const [openReturnRunnerIsFinishedToast, setOpenReturnRunnerIsFinishedToast] = useState(false)
    const [openReturnedToast, setOpenReturnedToast] = useState(false)

    const handleGetShipments = (page = 1) => {
        let retrievedShipment = []
        let ccShipmentsCount = 0
        let ccShipmentPageCount = 0
        let returnShipmentCount = 0
        let returnShipmentPageCount = 0
        getShipmentInCCTransit(currentInventory, page).then((res) => {
            if (res["hydra:member"].length > 0) {
                retrievedShipment = res["hydra:member"]
            }

            // Here total items is divided by 30 which is the maximum amount of items that can be fetched by the API
            ccShipmentsCount = res["hydra:totalItems"]
            ccShipmentPageCount = Math.ceil(res['hydra:totalItems'] / 30)
            getShipmentInReturn(currentInventory, currentOrganization?.syliusReturnRequestFeature, page).then((res) => {
                if (res["hydra:member"].length > 0) {
                    retrievedShipment = [...retrievedShipment, ...res["hydra:member"]]
                }

                returnShipmentCount = res["hydra:totalItems"]
                returnShipmentPageCount = Math.ceil(res['hydra:totalItems'] / 30)

                const formattedList = formatShipmentList(retrievedShipment)

                setShipments(formattedList)
                setApiTotalItemsCount(ccShipmentsCount + returnShipmentCount)
                setPageCount(ccShipmentPageCount >= returnShipmentPageCount ? ccShipmentPageCount : returnShipmentPageCount)
                setIsLoading(false)
            })
        })
    }

    const formatShipmentList = (res) => {
        if (res.length === 0) {
            setCurrentPageShipments([])
            setDisplayedShipments([])
            return []
        }

        let counter = 0
        let data = []
        res.map((shipment) => {
            let page = data.find(d => d.index === counter && d.items.length < 60)

            if (page) {
                page.items.push(shipment)
            } else {
                counter++
                const newPage = {
                    index: counter,
                    items: [
                        shipment
                    ]
                }
                data.push(newPage)
            }
        })
        const firstPage = data.find((page) => page.index === 1).items
        setCurrentPageShipments(firstPage)
        setDisplayedShipments(firstPage)
        return data
    }

    const resetList = () => {
        setIsLoading(true)
        handleGetShipments()
    }


    const handlePageChange = (newPage) => {
        setIsLoading(true)
        setCurrentPage(newPage)
        handleGetShipments(newPage)
        setDisplayedShipments([])
    }

    const handleCloseShipmentModal = () => {
        setOpenShipmentModal(false)
        setSelectedShipment(null)
    }

    const handleCloseReturnShipmentModal = () => {
        setOpenReturnShipmentModal(false)
        setSelectedShipment(null)
    }

    const handleCloseErrorModal = () => {
        setOpenErrorModal(false)
    }

    const handleCloseZoneDrawer = () => {
        setOpenZoneDrawer(false)
        setSelectedShipment(null)
    }

    const handleCloseValidProductDrawer = () => {
        setOpenValidProductDrawer(false)
        setSelectedShipment(null)
        setIsLoading(true)
        handleGetShipments()
    }

    const handleCloseToast = () => {
        setOpenToast(false)
    }

    const handleManualChoice = () => {
        setOpenZoneDrawer(true)
        setOpenShipmentModal(false)
    }

    const handleBeginReturnValidation = () => {
        setOpenValidProductDrawer(true)
        setOpenReturnShipmentModal(false)
    }

    const handleZoneOrTrolleySelection = (selectedObject) => {
        setOpenZoneDrawer(false)
        setOpenShipmentModal(false)

        assignShipmentToContainer(selectedObject.containerCodebar, selectedShipment.id).then(() => {
            setShipmentsInInventory(selectedShipment.id, currentInventory.id).then(() => {
                setOpenToast(true)
                resetList()
            })
        })
    }

    const handleCloseReturnedToast = () => {
        setOpenReturnedToast(false)
    }

    const getShipmentType = (shipment) => {
        if (shipment.status === ShipmentStatus.CC_TRANSIT) {
            return (<FormattedMessage id={"wms.receptionList.shipmentType.cc"}/>)
        } else {
            const lineItems = shipment.lineItems

            if (lineItems.some(lineItem => LineItemStatus.RETURNING_RUNNER === lineItem.status)) {
                return (<FormattedMessage id={"wms.receptionList.shipmentType.returnRunner"}/>)
            } else {
                    return (<FormattedMessage id={"wms.receptionList.shipmentType.returnRetailer"}/>)
            }
        }
    }

    const handleFinishReturn = () => {
        if (isRunner) {
            setOpenReturnRunnerIsFinishedToast(true)
        } else {
            setOpenReturnedToast(true)
        }
    }

    useEffect(() => {
        let isAborted = false;

        const delayDebounceFn = setTimeout(() => {
            if (!searchString || searchString.length === 0) {
                setDisplayedShipments(currentPageShipments)
            } else {
                getShipmentByExternalDeliveryNumber(searchString, currentInventory).then((shipments) => {
                    if (!isAborted) {
                        setDisplayedShipments(shipments)
                    }
                });
            }
        }, 500);

        return () => {
            isAborted = true;
            clearTimeout(delayDebounceFn);
            abort.abortRequests();
        };
    }, [searchString]);

    const handleReturnShipment = () => {
        const lineItems = selectedShipment.lineItems

        if (lineItems.every(item => LineItemStatus.CONFIRMED === item.status || LineItemStatus.RETURNING_RETAILER === item.status)) {
            setIsRunner(false)
        } else {
            setIsRunner(true)
        }

        setOpenReturnShipmentModal(true)
    }

    useEffect(() => {
        if (currentInventory) {
            setIsLoading(true)
            handleGetShipments();
        }
    }, [currentInventory]);

    useEffect(() => {
        if (selectedShipment && !openValidProductDrawer) {
            if (ShipmentStatus.CC_TRANSIT ===  selectedShipment.status) {
                setIsCC(true)
                setOpenShipmentModal(true)
            } else {
                setIsCC(false)
                handleReturnShipment()
            }

        }
    }, [selectedShipment]);

    useEffect(() => {
        if (scannedString && scannedString.length > 0) {
            if(!openShipmentModal && !openZoneDrawer) {
                getShipmentByExternalDeliveryNumber(scannedString, currentInventory).then((shipments) => {
                    if (shipments.length === 0) {
                        setOpenErrorModal(true);
                    } else {
                        setSelectedShipment(shipments[0])
                        setOpenShipmentModal(true)
                    }
                }).catch(() => {
                    setOpenErrorModal(true);
                }).finally(() => resetScannedString())
            }

            if (openShipmentModal || openZoneDrawer) {
                getWMSContainerWithCodeBar(scannedString).then((response) => {
                    if (WmsContainerType.CC === response.type) {
                        response.containerCodebar = response.codebar
                        handleZoneOrTrolleySelection(response)
                    } else if(WmsContainerType.TROLLEY === response.type) {
                        if (response.wmsItems.length === 0) {
                            response.containerCodebar = response.codebar
                            handleZoneOrTrolleySelection(response)
                        }
                    }
                })
            }
        }
    }, [scannedString]);

    return (
        <WmsMobileLayout>
            <WmsMobileLayout.LeftHeader>
            </WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader>
            </WmsMobileLayout.RightHeader>
            <WmsMobileLayout.Content>
                {openShipmentModal && (
                    <CCShipmentModal
                        open={openShipmentModal}
                        setOpen={setOpenShipmentModal}
                        handleClose={handleCloseShipmentModal}
                        selectedShipment={selectedShipment}
                        handleManualChoice={handleManualChoice}
                    />
                )}

                {openErrorModal && (
                    <CCErrorModal
                        open={openErrorModal}
                        handleClose={handleCloseErrorModal}
                    />
                )}

                {openReturnShipmentModal && (
                    <ReturnShipmentModal
                        open={openReturnShipmentModal}
                        handleClose={handleCloseReturnShipmentModal}
                        selectedShipment={selectedShipment}
                        handleBeginValidation={handleBeginReturnValidation}
                    />
                )}

                {openReturnedToast && (
                    <Toast
                        open={openReturnedToast}
                        handleClose={handleCloseReturnedToast}
                        title={<FormattedMessage id={"wms.receptionList.shipmentReturned"}/>}
                        subtitle={<FormattedMessage id={"wms.ccReceptionList.finishReturn.toast.subtitle"}/>}
                        icon={<ValidIcon/>}
                        isTop={!isMobile}
                        isDesktop={!isMobile}
                    />
                )}

                {openReturnRunnerIsFinishedToast && (
                    <Toast
                        open={openReturnRunnerIsFinishedToast}
                        handleClose={() => setOpenReturnRunnerIsFinishedToast(false)}
                        title={<FormattedMessage id={"wms.ccReceptionList.finishReturn.toast.title"}/>}
                        subtitle={<FormattedMessage id={"wms.ccReceptionList.finishReturn.toast.subtitle"}/>}
                        icon={<ValidIcon/>}
                        isTop={!isMobile}
                        isDesktop={!isMobile}
                    />
                )}

                {openZoneDrawer && (
                    <TrolleyOrZoneDrawer
                        open={openZoneDrawer}
                        handleClose={handleCloseZoneDrawer}
                        handleZoneOrTrolleySelection={handleZoneOrTrolleySelection}
                    />
                )}

                {openValidProductDrawer && (
                    <ValidProductDrawer
                        open={openValidProductDrawer}
                        handleClose={handleCloseValidProductDrawer}
                        shipmentId={selectedShipment.id}
                        isRunner={isRunner}
                        handleFinishReturn={handleFinishReturn}
                    />
                )}

                {openToast && (
                    <Toast
                        open={openToast}
                        handleClose={handleCloseToast}
                        title={<FormattedMessage id={'wms.ccReception.toast.title'}/>}
                        subtitle={<FormattedMessage id={'wms.ccReception.toast.subtitle'}/>}
                        isDesktop
                        isTop
                        icon={
                            <img style={{
                                height: '20px',
                                width: '20px'
                            }}
                                 src={<ValidIcon/>}
                                 alt={"validated-icon"}
                            />}
                    />
                )}
                <Card>
                    <CardContent>
                        <Grid container justifyContent={"space-between"} alignContent={"center"}>
                            <PageTitle
                                title={<FormattedMessage id={"wms.receptionList.title"}/>}
                                subtitle={<FormattedMessage id={"wms.receptionList.subtitle"}/>}
                                isDesktop={true}
                            />
                            <SearchBar
                                customPlaceholder={'wms.ccReceptionList.search.placeholder'}
                                onChange={(value) => setSearchString(value)}
                            />
                        </Grid>
                    </CardContent>
                </Card>
                <div style={{background: '#FFF'}}>
                    <div style={{maxHeight: "60vh", overflowX: 'scroll'}}>
                        {isLoading ? (
                            <div style={{textAlign: "center"}}>
                                <BeatLoaderRegular loading={true} size={15} />
                            </div>
                        ) : (
                        <Table>
                            <TableHead>
                                <TableRowHead>
                                    {[
                                        {label: <FormattedMessage id='wms.cc.list.table.header.trackingNumber'/>},
                                        {label: <FormattedMessage id='wms.cc.list.table.header.orderNumber'/>},
                                        {label: <FormattedMessage id='wms.cc.list.table.header.parcelType'/>},
                                        {label: <FormattedMessage id='wms.cc.list.table.header.date'/>,},
                                        {label: <FormattedMessage id='wms.cc.list.table.header.action'/>}
                                    ].map((column, index) => (
                                        <TableCellHead
                                            key={index}
                                        >
                                            {column.label}
                                        </TableCellHead>
                                    ))}
                                </TableRowHead>
                            </TableHead>
                            <TableBody>
                                {displayedShipments.length > 0 && displayedShipments.map((shipment) => (
                                    <TableRow key={shipment.id}>
                                        <TableCell>
                                            <span style={{color: blueColor}}>{shipment.externalDeliveryNumber}</span>
                                        </TableCell>
                                        <TableCell>
                                            {shipment.order.externalId}
                                        </TableCell>
                                        <TableCell>
                                            <span>{getShipmentType(shipment)}</span>
                                        </TableCell>
                                        <TableCell>
                                            <FormattedDate value={shipment.createdAt}/>
                                        </TableCell>
                                        <TableCell>
                                            <ActionLink
                                                onClick={() => {
                                                    setSelectedShipment(shipment);
                                                }}
                                            >
                                                <FormattedMessage id='wms.ccReceptionList.table.action'/>
                                            </ActionLink>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        )}
                    </div>
                    <Pagination
                        pageCount={pageCount}
                        handlePageChange={(page) => {handlePageChange(page)}}
                    />
                </div>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>

    );
}

export default CcReceptionList;
